<template>
    <nav aria-label="breadcrumb">
        <ol class="breadcrumb">
            <li class="breadcrumb-item">
                <a :href=route_back>Список брендов</a>
            </li>
            <li class="breadcrumb-item active" aria-current="page">Добавить бренд</li>
        </ol>
    </nav>

    <div class="col-md-4 col-12">
        <div class="form-row mb-4">
            <div class="col-md-12">
                <label class="form-label" for="input_name_client_id">Клиент <span class="color-red">*</span></label>
                <v-select
                    :disabled="picked_client === 0 && client_id === 0"
                    id="input_name_client_id"
                    v-model="formData.client_id"
                    :items="clients"
                    item-title="name"
                    item-value="id"
                    variant="outlined"
                    color="primary"
                    density="compact"
                    clearable
                    @update:menu="$removeFocus"
                    @click:clear="$removeFocus"
                    @click:control="$removeFocus">
                    <template #no-data>
                        <v-list-item>
                            <span>Данные не найдены</span>
                        </v-list-item>
                    </template>
                </v-select>
            </div>
        </div>

        <div class="form-row mb-4">
            <div class="col-md-12">
                <label class="form-label" for="brand-name">Название бренда <span class="color-red">*</span></label>
                <input type="text" class="form-control" id="brand-name" v-model="formData.name" placeholder="Введите название бренда">
            </div>
        </div>

        <div class="form-row mb-4">
            <div class="col-md-12">
                <label class="form-label" for="brand-img">Логотип бренда</label>
                <input type="text" class="form-control" id="brand-img" v-model="formData.img" placeholder="Укажите путь до логотипа">
            </div>
        </div>
    </div>

    <div class="d-flex w-50 align-items-center justify-content-start">
        <ConfirmBtn :class="'btn btn-lg btn-primary me-3'" :text="'Добавить'" @btnClick="createBrand"/>
        <a class="btn btn-lg btn-outline-dark" :href="route_back">Отменить</a>
    </div>

    <Alert />
</template>

<script>
import ConfirmBtn from "../../../../elements/ConfirmBtn.vue";
import Brand from "../../../../models/Brand";
import Alert from "../../../alerts/Alert.vue";
import { mapMutations } from "vuex/dist/vuex.cjs.js";

export default {
    name: "BrandCreateComponent",
    components: { Alert, ConfirmBtn },
    props: {
        route_back: String,
        route_client_search: String,
        route_create: String
    },
    data: function () {
       return {
           brand: new Brand({
               route_client_search: this.route_client_search,
               route_create: this.route_create
           }),
           clients: [],
           formData: {
               client_id: null,
               name: '',
               img: ''
           },
       }
    },
    methods: {
        ...mapMutations('alerts', ['addAlert']),
        ...mapMutations('ui', ['toggleLoading']),
        createBrand: async function () {
            if (this.formData.client_id === 0) {
                this.addAlert({ type: 'error', title: 'Ошибка', text: 'Выберите клиента!' });
                this.toggleLoading();
                return;
            }
            if (this.formData.name === '') {
                this.addAlert({ type: 'error', title: 'Ошибка', text: 'Укажите название бренда!' });
                this.toggleLoading();
                return;
            }
            let result = await this.brand.create(this.formData);
            if(result)
            {
                window.location.href = this.route_back;
            }
            else
            {
                console.log('error: create_brand');
                this.toggleLoading();
            }
        },
        searchClients: async function () {
            let clients = await this.brand.clients();
            this.clients = clients.items;
        },
    },
    mounted() {
        this.searchClients();
    }
}
</script>

<style scoped>

</style>
